import { GrowthBook } from "@growthbook/growthbook-react";

// Initializes a singleton GrowthBook instance for the frontend app.
// It is safe to use even when GrowthBook env vars are not configured.
// To enable, set:
//   REACT_APP_GROWTHBOOK_API_HOST=https://cdn.growthbook.io
//   REACT_APP_GROWTHBOOK_API_KEY=gbk_... (client key)
// Optionally, you can set user attributes via setAttributes.

export let growthbook = null;

let started = false;

export function initGrowthBook(attributes = {}) {
  if (started && growthbook) return growthbook;

  const apiHost = process.env.REACT_APP_GROWTHBOOK_API_HOST;
  const clientKey = process.env.REACT_APP_GROWTHBOOK_API_KEY;

  growthbook = new GrowthBook({
    enableDevMode: process.env.NODE_ENV !== "production",
    apiHost,
    clientKey,
  });

  // If not configured, don't attempt to load features. Everything stays off.
  if (!apiHost || !clientKey) {
    console.warn(
      "GrowthBook is not configured. Set REACT_APP_GROWTHBOOK_API_HOST and REACT_APP_GROWTHBOOK_API_KEY to enable feature flags.",
    );
    // Mark ready so FeaturesReady doesn't block the app when flags are disabled.
    growthbook.setFeatures({});
    growthbook.setAttributes({
      ...attributes,
      // reasonable defaults
      app: "frontend",
      environment: process.env.NODE_ENV || "development",
    });
    started = true;
    return growthbook;
  }

  growthbook.setAttributes({
    ...attributes,
    app: "frontend",
    environment: process.env.NODE_ENV || "development",
  });

  // init() is the current API; ok to fire-and-forget to avoid blocking render.
  growthbook.init({}).catch((error) => {
    console.warn("GrowthBook init failed", error);
  });
  started = true;
  return growthbook;
}

export function isOn(flagKey, fallback = false) {
  try {
    if (!growthbook) return !!fallback;
    return growthbook.isOn(flagKey);
  } catch (e) {
    return !!fallback;
  }
}
